@if (!!icon) {
    <fa-icon  [icon]="icon" [size]="size" [fixedWidth]="fixedWidth" [animation]="spin ? 'spin' : null"></fa-icon>
}
